import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'; 
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';
import { Product,DefaultProduct } from './myconfiguration.component';

@Injectable({
  providedIn: 'root'
})
export class MyconfigurationService {
constructor(private httpClient: HttpClient) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + "/common/myconfiguration"

  addMyconfiguration(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/addmyconfiguration`, payload);
  }

  modifyMyconfiguration(myconfigurationid, payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/modifymyconfigurationbyid/${myconfigurationid}`, payload);
  }

  getAllMyconfiguration(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/getallmyconfiguration`);
  }

  getMyconfigurationById(id): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/getmyconfigurationbyid/${id}`);
  }

  myconfigurationexcelData(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/getmyconfigurationdataexcel`, { responseType: 'blob' });
  }
  getProducts(): Observable<Product[]> {
    return this.httpClient.get<Product[]>(`${this.baseURL}/getproduct`);
  }

  getdefproduct(): Observable<DefaultProduct[]> {
    return this.httpClient.get<DefaultProduct[]>(`${this.baseURL}/getdefproduct`);
  }

  userproductconfigurationmodify(formData): Observable<DefaultProduct[]> {
    return this.httpClient.post<DefaultProduct[]>(`${this.baseURL}/userproductconfigurationmodify`, formData);
  }

  getUserDashboardConfiguration(productid: string): Observable<any> {
    return this.httpClient.get<DefaultProduct[]>(`${this.baseURL}/getuserdashboardconfiguration/${productid}`);
  }

  getfrequencydayconfiguration(activeflag: string): Observable<any> {
    return this.httpClient.get<DefaultProduct[]>(`${this.baseURL}/getfrequencydayconfiguration/${activeflag}`);
  }

  getdetails(): Observable<any> {
    return this.httpClient.get<DefaultProduct[]>(`${this.baseURL}/getdetails`);
  }
  toggleEmailStatus(csrftoken): Observable<Object> {
    return this.httpClient.post<DefaultProduct[]>(`${this.baseURL}/toggleEmailStatus`, {
      csrftoken
    });
  }

  userdashboardconfigurationmodify(payload: any): Observable<any> {
    return this.httpClient.post<any>(`${this.baseURL}/userdashboardconfigurationmodify`, payload);
  }

  exists(email: string): Observable<any> {
    return this.httpClient.get<DefaultProduct[]>(`${this.baseURL}/exists/${email}`);
  }

  verifyemail(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/verifyemail`, payload);
  }

}
